import React, { Component } from "react";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import { withStyles } from "material-ui/styles";
import { connect } from 'react-redux';
import { compose } from 'recompose';

import styles from "./styles";

const Title = props => {
  const { 
    classes,
    title,
    toolbar,
    custTitle,
    custName,
    back,
    logo,
    deepLink,
    impersonating,
    softwareUpdate,
    backCheck = null
  } = props;

  let margintop = "60px";

    if (impersonating && softwareUpdate) {
      margintop = "180px";
    } else if (impersonating || softwareUpdate) {
      margintop = "120px";
    }

  return (
    <AppBar position="fixed" className={classes.functionBar} style={{ marginTop: margintop }}>
      <div className={classes.centred}>
        <Toolbar>
          {custTitle && (
            <Typography className={classes.custTitle}>
              <Typography type="headline" className={classes.functionBarTitle}>
                {custTitle}
              </Typography>
            </Typography>
          )}
          {custName && (
            <Typography className={classes.custName}>
              <Typography type="headline" className={classes.functionBarTitle}>
                {custName}
              </Typography>
            </Typography>
          )}
          {deepLink}
          <Typography type="headline" className={classes.functionBarTitle}>
            {back}
          </Typography>
          <Typography type="headline" className={classes.functionBarTitle}>
            {backCheck}
          </Typography>
          <Typography type="headline" className={classes.functionBarTitle}>
            {title}
          </Typography>
          <div className={classes.flex}>
            <img src={logo} style={{ height: 45 }} />
          </div>
          {toolbar} 
        </Toolbar>
      </div>
    </AppBar>
  );
};

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Title);



// WEBPACK FOOTER //
// ./src/components/ui/title/index.js